import { jsxs, jsx } from 'react/jsx-runtime';
import { useState, useRef, useEffect } from 'react';
import styled from '@emotion/styled';
import { Tooltip } from '@monorepo/tooltip';
import { activateLabel, BoxInputContainer, BoxInputOuterContainer, BoxInputLabel, BoxInputError } from '@monorepo/base-box-input';

// Include support for DR elements
// https://docs.digitalriver.com/commerce-api/payment-integrations-1/digitalriver.js/reference/elements
const TextBoxContainer = styled(BoxInputContainer) `
    .DRElement {
        padding: 0;
        font-family: ${({ theme }) => theme.fontStacks.default};

        & + label {
            ${({ disabled, theme }) => activateLabel(true)}
        }

        &.DRElement--empty:not(.DRElement--focus) + label {
            ${({ disabled, theme }) => activateLabel(false)}
        }

        &.DRElement--webkit-autofill + label {
            color: #1a1a1a;
        }

        > iframe {
            height: 100% !important;
        }
    }
`;
const TextBox = (props) => {
    const [isActive, setIsActive] = useState(!!props.value);
    const [showTooltip, setShowTooltip] = useState(false);
    const textBoxRef = useRef(null);
    const { className, type, label, icon, iconUrl, iconStyles, tooltip, errorMessage, value, onChange, disabled, drElementId, "data-testid": dataTestId, ...rest } = props;
    // clear active state if input is cleared and element is not in focus
    useEffect(() => {
        if (document.activeElement !== textBoxRef.current) {
            setIsActive(!!value);
        }
    }, [value]);
    const onFocusHandler = () => {
        setIsActive(true);
    };
    const onBlurHandler = () => {
        if (!value) {
            setIsActive(false);
        }
    };
    return (jsxs(BoxInputOuterContainer, { className: className, disabled: disabled, children: [tooltip && jsx(Tooltip, { ...tooltip, externalOpen: showTooltip }), jsxs(TextBoxContainer, { disabled: disabled, hasError: !!errorMessage, hasIcon: !!iconUrl || !!icon, hasLabel: !!label, isActive: isActive, onFocus: onFocusHandler, onBlur: onBlurHandler, "data-testid": dataTestId, children: [drElementId ? (jsx("div", { className: "input-el", id: drElementId })) : (jsx("input", { disabled: disabled, className: "input-el", type: type || "text", value: value, onChange: onChange, ref: textBoxRef, ...rest })), jsx(BoxInputLabel, { isActive: isActive, disabled: disabled, children: label }), iconUrl && (jsx("img", { src: iconUrl, style: iconStyles, onMouseOver: () => setShowTooltip(true), onMouseLeave: () => setShowTooltip(false) })), icon] }), jsx(BoxInputError, { className: errorMessage && "shown", children: errorMessage })] }));
};

export { TextBox };
